/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IFlujos from 'Infotrack@Modelos/smartStock/flujos/entidades/flujos';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import FlujosCM from '../controladorModelo/flujosCM';
import { IFormularioFlujosCVProps } from '../interfaces';
import { acciones, IEstadoFlujos } from '../reductorFlujos';
import FormularioFlujosVista from '../vista/formularioFlujosVista';
import { useSelector } from 'react-redux';

const estadoInicial: IFlujos = {
    EmpresaId: '',
    FlujoDescripcion: '',
    Estado: false,
    AgenciaId: '',
};
const flujosCM = new FlujosCM();

const FormularioFlujosCV: React.FunctionComponent<IFormularioFlujosCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadFlujos }, dispatch] = useProveedor<IEstadoFlujos>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IFlujos>(estadoInicial);

    React.useEffect(() => {
        if (entidadFlujos && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadFlujos);
        } else {
            reiniciar();
        }
    }, [entidadFlujos]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionFlujos = () => {
        if (flujosCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarFlujos,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarFlujos = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            flujosCM
                .crearFlujos({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            flujosCM
                .editarFlujos({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioFlujosVista
            accionCrearEditar={confirmarCreacionEdicionFlujos}
            cambiarInfoFomulario={alCambiarValor}
            flujos={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioFlujosCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioFlujosCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioFlujosCV);
